let leaving = false;

if (typeof window !== 'undefined') {
  window.addEventListener('pagehide', () => { leaving = true; });
  window.addEventListener('pageshow', () => { leaving = false; });
}

/** True once the page is unloading. A request the browser cuts off then is not a failure to log or report. */
export function isPageLeaving(): boolean {
  return leaving;
}
